/* eslint-disable no-useless-escape */
const REGEXS = {
    name: /^[A-Za-z ]*$/,
    // name: /^[A-Z](?!.* {2})[ \w.-]{2,24}$/,
    // email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    mobile: /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#^`~$!%*?&])[A-Za-z\d@#^`~$!%*?&]{8,20}$/,
    pincode: /^[1-9]{1}[0-9]{5}$/,
    // examName: /^([A-Za-z][A-Za-z/0-9]{0,})((?: )(?:[A-Za-z0-9][A-Za-z/0-9]{0,}){0,}(?:[-]){0,}(?:[,]){0,}(?: [&]){0,}(?: [(][A-Za-z0-9][A-Za-z/0-9]{0,}(?: [A-Za-z0-9][A-Za-z/0-9]{0,}){0,}[)]){0,}(?: [A-Za-z0-9][A-Za-z/0-9]{0,}){0,}){0,}$/,
    // examName: /^(([A-Za-z0-9/()&,-]{0,}(?: ){0,1}))*$/,
    examName: /^[A-Za-z0-9? .''()\/&,_-]*$/,
    // title: /^([A-Za-z0-9]{1,40})(?: [A-Za-z0-9]{1,40}){0,}(?: [(][A-Za-z0-9]{1,40}[)]){0,1}$/,
    link: /^(?!mailto:)(?:(?:http|https|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))|localhost)(?::\d{2,5})?(?:(\/|\?|#)[^\s]*)?$/,
    // description: /^[^\s].+[^\s]$/,
    stepName: /^[A-Za-z0-9 ]+$/,
    place: /^[A-Za-z ]*$/,
    religion: /^[A-Za-z ]*$/,

    number: /^[0-9]*$/,
    alplabhets: /^[A-Za-z ]*$/,
    alplabhetNumeric: /^[A-Za-z0-9 ]*$/,
    alplabhetNumericWithSpecial: /^[ A-Za-z0-9_@./'"#&(),+-]*$/,
    past_reg_number: /^[1-9]{1}[0-9]{8}$/,
    idProofRegex: {
        1: /^[2-9][0-9]{11,11}$/,
        2: /^[A-Za-z]{3}\d{7}$/,
        3: /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/,
        4: /^(([A-Za-z]{2}[0-9]{2})( )|([A-Za-z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
        5: /[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}/,
    }
}

export default REGEXS;